import { z } from 'zod';
import { ArtistIdSchema } from './common.js';
import { SelectorsSchema } from './selectors.js';
export const RoleSchema = z.enum(['reader', 'analyst']);
export const MeSchema = z.object({
    upn: z.string(),
    name: z.string().nullable(),
    role: RoleSchema,
    expiresAt: z.iso.datetime(),
});
export const UserPrefsSchema = z.object({
    lastArtistId: ArtistIdSchema.optional(),
    selectors: SelectorsSchema.partial().optional(),
    /** Ad-hoc peers per subject artist. */
    adHocPeers: z.record(ArtistIdSchema, z.array(ArtistIdSchema)).optional(),
});
//# sourceMappingURL=me.js.map